import { atom, selector } from "recoil";

export interface CFDConfig {
  carType: string;
  openfoamVersion: string;
  model: string;
  velocity: number;
  note: string;
}

export const cfdConfigState = atom<CFDConfig>({
  key: 'cfdConfigState',
  default: {
    carType: 'wing',
    openfoamVersion: 'v0.2.1',
    model: 'steady',
    velocity: 38.89,
    note: '',
  }
});

// `carType`プロパティに対するRecoilState
export const carTypeState = selector<string>({
  key: 'carTypeState',
  get: ({ get }) => {
    const cfdConfig = get(cfdConfigState);
    return cfdConfig.carType;
  },
  set: ({ get, set }, newValue) => {
    const cfdConfig = get(cfdConfigState);
    set(cfdConfigState, {
      ...cfdConfig,
      carType: newValue as string,
    });
  },
});

// `openfoamVersion`プロパティに対するRecoilState
export const openfoamVersionState = selector<string>({
  key: 'openfoamVersionState',
  get: ({ get }) => {
    const cfdConfig = get(cfdConfigState);
    return cfdConfig.openfoamVersion;
  },
  set: ({ get, set }, newValue) => {
    const cfdConfig = get(cfdConfigState);
    set(cfdConfigState, {
      ...cfdConfig,
      openfoamVersion: newValue as string,
    });
  },
});

// `model`プロパティに対するRecoilState
export const cfdModelState = selector<string>({
  key: 'cfdModelState',
  get: ({ get }) => {
    const cfdConfig = get(cfdConfigState);
    return cfdConfig.model;
  },
  set: ({ get, set }, newValue) => {
    const cfdConfig = get(cfdConfigState);
    set(cfdConfigState, {
      ...cfdConfig,
      model: newValue as string,
    });
  },
});

// `velocity`プロパティに対するRecoilState
export const velocityState = selector<number>({
  key: 'velocityState',
  get: ({ get }) => {
    const cfdConfig = get(cfdConfigState);
    return cfdConfig.velocity;
  },
  set: ({ get, set }, newValue) => {
    const cfdConfig = get(cfdConfigState);
    set(cfdConfigState, {
      ...cfdConfig,
      velocity: newValue as number,
    });
  },
});

// `note`プロパティに対するRecoilState
export const noteState = selector<string>({
  key: 'noteState',
  get: ({ get }) => {
    const cfdConfig = get(cfdConfigState);
    return cfdConfig.note;
  },
  set: ({ get, set }, newValue) => {
    const cfdConfig = get(cfdConfigState);
    set(cfdConfigState, {
      ...cfdConfig,
      note: newValue as string,
    });
  },
});
